import { useEffect, useLayoutEffect } from 'react';
import {
  BrowserRouter,
  Navigate,
  Routes,
  Route,
  useLocation
} from 'react-router-dom';
import { BlogPostPage } from '@/features/Blog';
import { CasesPage } from '@/features/Cases';
import { ContactPage } from '@/features/Contact';
import { InsightsPage } from '@/features/Insights';
import HomePage from '@/features/Home/HomePage';
import NotFoundPage from '@/features/NotFound/NotFoundPage';
import BackToTopButton from '@/shared/components/BackToTopButton';
import { I18nProvider } from '@/shared/contexts/I18nProvider';

type RouteLocationState = {
  scrollToSection?: unknown;
};

const ScrollToTop = () => {
  const location = useLocation();
  const routeState = location.state as RouteLocationState | null;
  const hasSectionTarget = typeof routeState?.scrollToSection === 'string';

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useLayoutEffect(() => {
    if (hasSectionTarget) {
      return;
    }

    window.scrollTo(0, 0);
  }, [hasSectionTarget, location.pathname]);

  return null;
};

export const AppRouter = () => {
  return (
    <BrowserRouter>
      <I18nProvider>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/index" element={<Navigate to="/" replace />} />
          <Route path="/index/" element={<Navigate to="/" replace />} />
          <Route path="/index.html" element={<Navigate to="/" replace />} />
          <Route path="/cases" element={<CasesPage />} />
          <Route path="/insights" element={<InsightsPage />} />
          <Route path="/insights/page/:pageNumber" element={<InsightsPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/news/:slug" element={<BlogPostPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <BackToTopButton />
      </I18nProvider>
    </BrowserRouter>
  );
};
